<template>
  <div id="left-secondary-navigation">
    <div class="secondary-header" v-if="index == 1">
      <img src="@/assets/images/add/h1.png" />
      <div>Home Page</div>
    </div>
    <div class="secondary-header" v-if="index == 2">
      <img src="@/assets/images/add/h2.png" />
      <div>Basic Business</div>
    </div>
    <div class="secondary-header" v-if="index == 3">
      <img src="@/assets/images/add/h3.png" />
      <div>Shopping Mall</div>
    </div>
    <div class="secondary-header" v-if="index == 4">
      <img src="@/assets/images/add/h4.png" />
      <div>Distribution Management</div>
    </div>
    <div class="secondary-header" v-if="index == 5">
      <img src="@/assets/images/add/h5.png" />
      <div>SystemSettings</div>
    </div>
    <div class="secondary-header" v-if="index == 6">
      <img src="@/assets/images/add/h6.png" />
      <div>Message Notification</div>
    </div>
    <div class="secondary-header" v-if="index == 7">
      <img src="@/assets/images/add/h7.png" />
      <div>Local Life</div>
    </div>
    <div class="secondary-line"></div>
    <div class="secondary-list">
      <div v-for="item in nav" :key="item.id" @click="handleNav(item)">
        <div
          :class="[
            'secondary-item',
            navId == item.id ? 'secondary-item-active' : '',
          ]"
        >
          {{ item.name }}
        </div>
        <div v-if="item.child && navId == 99" class="nav-list">
          <div
            @click.stop="handleNav2(items)"
            :class="['nav-item', navId2 == items.id ? 'nav-item-active' : '']"
            v-for="items in item.child"
            :key="items.id"
          >
            {{ items.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LeftSecondaryNavigation",
  props: ["navArr", "index"],
  data() {
    return {
      navId: 1,
      navId2: "99",
      navChild: "",
      nav: [],
    };
  },
  mounted() {
    this.nav = this.navArr;
    console.log(this.nav);
    this.nav.forEach((item) => {
      if (this.$route.meta.fatherRoute == item.father) {
        this.navId = item.id;
        item.child.forEach((items) => {
          if (this.$route.path == items.url) {
            this.navId2 = items.id;
          }
        });
        return false;
      }
      if (this.$route.meta.fatherRoute == item.url) {
        this.navId = item.id;
      }
    });
  },
  methods: {
    handleNav2(item) {
      // console.log(item);
      this.navId2 = item.id;
      if (this.$route.path == item.url) {
        return false;
      }
      this.$router.push(item.url);
    },
    handleNav(item) {
      this.navId = item.id;
      if (item.id == 99) {
        this.navId2 = 22;
      }
      if (this.$route.path == item.url) {
        return false;
      }
      this.$router.push(item.url);
    },
  },
  watch: {
    navArr: {
      handler(val) {
        // console.log(val);
        this.nav = val;
        this.nav.forEach((item) => {
          if (
            this.$route.meta.fatherRoute == "/marketingSettings" &&
            item.father == "marketingSettings"
          ) {
            this.navId = item.id;
            // console.log(item);
            item.child.forEach((items) => {
              if (this.$route.path == items.url) {
                this.navId2 = items.id;
              }
            });
            return false;
          }
          if (this.$route.meta.fatherRoute == item.url) {
            this.navId = item.id;
          }
        });
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.nav.forEach((item) => {
          if (this.$route.meta.fatherRoute == item.url) {
            this.navId = item.id;
          }
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
#left-secondary-navigation {
  width: 193px;
  height: 100vh;
  background-color: $y-bg;
  position: relative;
  .secondary-header {
    font-size: 10px;
    text-align: center;
    padding: 38px 0 25px;
    img {
      display: block;
      margin: 0 auto 3px;
      width: 43px;
      height: 43px;
    }
    div {
      background: linear-gradient(45deg, #dbaf68 -0.09%, #795ad3 99.91%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .secondary-line {
    width: 141px;
    height: 1px;
    background: #e5e5ea;
    margin: 0 auto 16px;
  }
  .secondary-list {
    padding: 0 0 0 26px;
    .secondary-item {
      width: 167px;
      height: 42px;
      border-radius: 42px 0 0 42px;
      line-height: 42px;
      padding-left: 16px;
      color: #000;
      margin-bottom: 8px;
      font-size: 16px;
      cursor: pointer;
    }
    .secondary-item-active,
    .secondary-item:hover {
      background-color: #fff;
      color: $y-color;
    }
    .nav-item {
      padding-left: 36px;
      color: #333;
      width: 167px;
      height: 42px;
      border-radius: 42px 0 0 42px;
      line-height: 42px;
      color: #000;
      margin-bottom: 8px;
      font-size: 16px;
      cursor: pointer;
    }
    .nav-item-active,
    .nav-item:hover {
      color: $y-color;
    }
  }
}
</style>